import { useSelector } from "react-redux";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

const CreateEventFormTab = (props) => {
  const { eventId } = useParams();
  const location = useLocation();
  const eventState = useSelector((state) => state.event);
  const eventData = eventState?.data || {};
  const stepper = eventData?.stepper || {};
  const stepperIcon = eventData?.stepperIcon || {};

  const TabData = [
    {
      id: "basic",
      title: "Basic Info",
      link: "basic_info",
      step: stepper.step1 ?? true,
      isIcon: stepperIcon.icon1,
    },
    {
      id: "details",
      title: "Detail",
      link: "details",
      step: stepper.step2,
      isIcon: stepperIcon.icon2,
    },
    {
      id: "tickets",
      title: "Tickets",
      link: "tickets",
      step: stepper.step3,
      isIcon: stepperIcon.icon3,
    },
    {
      id: "settings",
      title: "Settings",
      link: "settings",
      step: stepper.step4,
      isIcon: stepperIcon.icon4,
    },
    {
      id: "addons",
      title: "Addons",
      link: "addons",
      step: stepper.step5,
      isIcon: stepperIcon.icon5,
    },
    {
      id: "publish",
      title: "Publish",
      link: "publish",
      step: stepper.step6 ?? stepper.step5,
      isIcon: stepperIcon.icon6,
    },
  ];

  const visibleTabs = TabData.filter(
    (tab) =>
      (props.isOnlyTicket === true &&
        (tab.id === "details" || tab.id === "tickets")) ||
      !props.isOnlyTicket
  );

  const activeIndex = Math.max(
    0,
    visibleTabs.findIndex((tab) => tab.id === props.Id)
  );
  const progressPercent =
    visibleTabs.length > 0
      ? ((activeIndex + 1) / visibleTabs.length) * 100
      : 0;

  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const isEdit = params.get("isEdit");

  return (
    <div className="evnt-nav event-create-stepper">
      <ul
        className="nav nav-pills event-create-stepper-list"
        style={{ "--step-count": visibleTabs.length }}
      >
        {visibleTabs.map((TabDataValue, index) => (
          <li
            onClick={() => {
              if (!TabDataValue.step && !TabDataValue.isIcon) {
                return;
              }
              navigate(
                `/myEvents/${eventId}/${TabDataValue.link}?${
                  !!isEdit ? "isEdit=true" : ""
                }`,
                {
                  state: {
                    ...(isEdit && { isOnlyTickets: true }),
                  },
                }
              );
            }}
            className="nav-item"
            key={TabDataValue.id}
          >
            <Link
              className={`nav-link ${
                props.Id === TabDataValue.id ? "active" : ""
              } ${
                !TabDataValue.step && !TabDataValue.isIcon ? " disabled" : ""
              }`}
              id={TabDataValue.id}
            >
              {!TabDataValue.step && !TabDataValue.isIcon && (
                <i className="las la-lock" aria-hidden="true"></i>
              )}
              {TabDataValue.isIcon && (
                <i className="las la-check" aria-hidden="true"></i>
              )}
              {TabDataValue.step &&
                !TabDataValue.isIcon &&
                props.Id !== TabDataValue.id && (
                  <span className="event-create-step-num">{index + 1}</span>
                )}{" "}
              {TabDataValue.title}
            </Link>
          </li>
        ))}
      </ul>
      <div
        className="event-create-progress"
        aria-hidden="true"
      >
        <span
          className="event-create-progress-bar"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
};

export default CreateEventFormTab;
